import { Action } from '@interstate/components/Action';
import { Typography } from '@interstate/components/Typography';
import { ChevronRightIcon } from '@interstate/components/Icons/ChevronRightIcon';
import { useDispatch, useSelector } from 'react-redux';
import * as configSelectors from '@makemydeal/dr-dash-store/selectors/config';
import * as dealTemplateActionCreators from '@makemydeal/dr-dash-store/actions/dealTemplateActionCreators';

const TemplatesCard = () => {
    const dispatch = useDispatch();
    const openDrawerToManageTemplate = () =>
        dispatch(dealTemplateActionCreators.triggerTemplateBuilderMode(true, 'manage-existing-templates'));

    const isDealTemplatesViewEnabled = useSelector(configSelectors.isDealTemplatesViewEnabled);

    if (!isDealTemplatesViewEnabled) {
        return null;
    }

    return (
        <>
            <Typography variant="h3" sx={{ marginBottom: '0px', marginTop: '10px' }}>
                Templates
            </Typography>
            <Action
                data-testid="link-to-show-templates-drawer"
                sx={{ textAlign: 'left' }}
                onClick={() => {
                    openDrawerToManageTemplate();
                }}
            >
                <Typography variant="anchor-block-sm" color="base.color.blue.700">
                    Deal Templates
                    <ChevronRightIcon fontSize={10} />
                </Typography>
            </Action>
        </>
    );
};

export default TemplatesCard;
